import { render, staticRenderFns } from "./suspendedPlayer.vue?vue&type=template&id=2369c70c&scoped=true&"
import script from "./suspendedPlayer.vue?vue&type=script&lang=js&"
export * from "./suspendedPlayer.vue?vue&type=script&lang=js&"
import style0 from "./suspendedPlayer.vue?vue&type=style&index=0&id=2369c70c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2369c70c",
  null
  
)

export default component.exports